import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { USAEPAYAchPageRoutingModule } from './usaepay-ach-routing.module';

import { USAEPAYAchPage } from './usaepay-ach.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { AddressDetailsPageModule } from '../../../../address-details/address-details.module';
import { CustomInputModule } from '../../../../common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    USAEPAYAchPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    AddressDetailsPageModule,
    CustomInputModule,
  ],
  declarations: [USAEPAYAchPage],
})
export class USAEPAYAchPageModule {}
